/**** cat.DevCamera */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'cat',
  table: 'DevCamera',
  title: "Видеокамеры",
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    dvrs: {
      apiType: apiTypes.DEFAULT,
      schema: 'cat',
      table: 'DevDVR',
      index: 'id',
      fields: ['depot_number'],
      customsql: 'SELECT dvr.id, vh.depot_number FROM cat."DevDVR" dvr INNER JOIN mgt."Vehicle" vh ON dvr.vehicle_id=vh.vehicle_id',
      format: (elem: any) => elem['depot_number'],
      autocomplete: true
    },
    devcamtype: {
      apiType: apiTypes.DEFAULT,
      schema: 'cat',
      table: 'DevCamera_Type',
      index: 'ip',
      fields: ['title'],
      format: (elem: any) => elem['title'],
    }
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px'
    },
    {
      name: 'index',
      title: 'Порядковый номер камеры',
      type: 'number',
      required: true
    },
    {
      name: 'dvr_id',
      title: 'Транспортное средство',
      type: 'number',
      required: true,
      connection: 'dvrs'
    },
    {
      name: 'camera_addr',
      title: 'Тип видеокамеры',
      type: 'text',
      required: true,
      connection: 'devcamtype'
    },
    // {
    //   name: 'camera_url',
    //   title: 'Адрес устройства',
    //   type: 'text',
    //   required: true,
    //   validate: (value: any) => /^[A-Za-z-0-9_-]+$/.test(value),
    //   validateError: 'Допустимы только буквы латинского алфавита, цифры и знаки "_" и "-"',
    // },
    // {
    //   name: 'width',
    //   title: 'Ширина разрешения',
    //   type: 'number',
    //   required: true
    // },
    // {
    //   name: 'height',
    //   title: 'Высота разрешения',
    //   type: 'number',
    //   required: true
    // },
    // {
    //   name: 'codec',
    //   title: 'Кодек видео',
    //   type: 'text',
    //   required: true,
    //   validate: (value: any) => /^[A-Za-z-0-9_-]+$/.test(value),
    //   validateError: 'Допустимы только буквы латинского алфавита, цифры и знаки "_" и "-"',
    // },
    // {
    //   name: 'framerate',
    //   title: 'Величина фреймрэйта',
    //   type: 'number',
    //   required: true
    // },
    // {
    //   name: 'bitrate',
    //   title: 'Битрэйт',
    //   type: 'number',
    //   required: true
    // },
    // {
    //   name: 'ref_frame',
    //   title: 'Периодичность опорных кадров',
    //   type: 'number',
    //   required: true
    // },
    // {
    //   name: 'mac',
    //   title: 'MAC-адрес',
    //   type: 'text',
    //   required: true,
    //   validate: (value: any) => /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/.test(value),
    //   validateError: 'Неверный формат MAC-адреса'
    // },
    // {
    //   name: 'port',
    //   title: 'Порт',
    //   type: 'number',
    //   required: true
    // },
    // {
    //   name: 'login',
    //   title: 'Логин',
    //   type: 'text',
    //   required: true,
    //   validate: (value: any) => /^[A-Za-z-0-9_-]+$/.test(value),
    //   validateError: 'Допустимы только буквы латинского алфавита, цифры и знаки "_" и "-"',
    // },
    // {
    //   name: 'password',
    //   title: 'Пароль',
    //   type: 'text',
    //   required: true
    // },
    // {
    //   name: 'profile',
    //   title: 'Профиль настроек',
    //   type: 'text',
    //   required: true
    // }
  ],
  newTemplate: {
    id: null,
    dvr_id: null,
    camera_addr: null,
    // width: null,
    // height: null,
    // codec: null,
    // framerate: null,
    // bitrate: null,
    // ref_frame: null,
    // mac: null,
    // port: null,
    // login: '',
    // password: '',
    // profile: '',
    // index: null,
    // camera_url: ''
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  widgets: [
    'camera_addvehicle'
  ],
  defaultSort: {
    field: 'id',
    direction: 'desc'
  },
  import: {
    header: [
      {
        title: 'camera_id',
        field: 'id',
      },
      {
        title: 'index',
        field: 'index',
      },
      {
        title: 'camera_type',
        field: 'camera_addr',
      },
      // {
      //   title: 'ip',
      //   field: 'camera_url',
      // },
      // {
      //   title: 'mac',
      //   field: 'mac',
      // },
      // {
      //   title: 'port',
      //   field: 'port',
      // },
      // {
      //   title: 'hor_resolution',
      //   field: 'width',
      // },
      // {
      //   title: 'vert_resolution',
      //   field: 'height',
      // },
      // {
      //   title: 'videocodec',
      //   field: 'codec',
      // },
      // {
      //   title: 'framerate',
      //   field: 'framerate',
      // },
      // {
      //   title: 'bitrate',
      //   field: 'bitrate',
      // },
      // {
      //   title: 'ref_frame_freq',
      //   field: 'ref_frame',
      // },
      // {
      //   title: 'login',
      //   field: 'login',
      // },
      // {
      //   title: 'password',
      //   field: 'password',
      // },
      // {
      //   title: 'profile',
      //   field: 'profile',
      // },
       {
         title: 'dvr_id',
         field: 'dvr_id',
       },
    ],
    example: `1;1;1;1`,
  },
};

export default config;